import React, { useEffect, useRef } from "react";
import { Formik, FormikProvider } from "formik";
import MonthPicker from "../../../views/capture/form/MonthPicker";

export default function TableProMonthPicker({ value, onSubmit, disabled }) {
  const textFieldRef = useRef(null);

  const handleFormikChange = newValue => {
    if (onSubmit) {
      onSubmit(newValue);
    }
  };

  useEffect(() => {
    if (!disabled && textFieldRef.current) {
      const timer = setTimeout(() => {
        if (textFieldRef.current) {
          textFieldRef.current.click();
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [disabled]);

  return (
    <Formik initialValues={{ expirationMonth: value || "" }} onSubmit={() => {}} enableReinitialize>
      {formikProps => (
        <FormikProvider
          value={{
            ...formikProps,
            setFieldValue: (field, val, shouldValidate) => {
              formikProps.setFieldValue(field, val, shouldValidate);
              if (field === "expirationMonth") {
                handleFormikChange(val);
              }
            },
          }}
        >
          <div style={{ pointerEvents: disabled ? "none" : "auto" }}>
            <MonthPicker
              name="expirationMonth"
              label="Expiration Month"
              disabled={disabled}
              textFieldRef={textFieldRef}
            />
          </div>
        </FormikProvider>
      )}
    </Formik>
  );
}
